import React from "react";

type CloseIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  color: string;
};

const CloseIcon = ({ onClick, color }: CloseIconProps) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M9 1L1 9M1 1L9 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloseIcon;
